import styled, { css } from 'styled-components';

import { basic, grey } from '../../theme/colors';

interface textProps {
  variant?: 'primary' | 'secondary' | 'warning' | 'danger' | 'alert' | 'good' | 'tertiary';
}

const basicStyle = css`
  display: inline-block;
  border-radius: 4px;
  border: none;
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  padding: 4px 8px;
`;

const variantStyles = (variant = 'primary') =>
  ({
    primary: css`
      ${basicStyle}
      background: ${basic.haydenAccent};
      color: #fff;
      font-size: 11px;
      font-weight: 600;
      padding: 2px 8px;
    `,
    secondary: css`
      ${basicStyle}
      background: ${basic.haydenBorder};
      color: ${basic.haydenAccent};
    `,
    tertiary: css`
      ${basicStyle}
      background: ${grey.haydenGreyShade5};
      color: ${basic.haydenNeutral};
    `,
    warning: css`
      ${basicStyle}
      background: ${basic.haydenOrange};
      color: #000;
    `,
    danger: css`
      ${basicStyle}
      background: ${basic.haydenRed};
      color: #000;
    `,
    alert: css`
      ${basicStyle}
      background: ${basic.haydenOrange};
      color: ${basic.haydenWhite};
    `,
    good: css`
      ${basicStyle}
      background: ${basic.haydenGreen};
      color: ${basic.haydenWhite};
    `,
  })[variant];

export const Badge = styled.span<textProps>`
  ${({ variant }) => variantStyles(variant)}
`;
